module.exports = __webpack_public_path__ + "6ccec8e0ec32201e0d9a2a7720fe9dee.pdf";